import { objectEntries, objectFromEntries, objectValues } from '~/web-frontend-core/base/lib';
import { BaseMobileCategories } from '~/web-frontend-core/store/line/outcomes.mobile/additional/categories/Base.mobile';
export const ALL_CATEGORY_ID = 'ALL';
/**
 * Категории с доп. категоией ВСЕ
 */
export class AllMobileCategories extends BaseMobileCategories {
    /**
     * Обновление фильтра таблицы доп.росписи
     * приходит полностью новое состояние, отсутсвующие категории удаляются
     * @example
     * ```
     *    categories.update(matchID, {
     *       [categoryID]: { isSelected: !categoryTab.isSelected }
     *    });
     * ```
     */
    update(matchID, sportID = this.sportID[matchID], config, categoriesLabels, newStates, selected) {
        if (newStates === null || categoriesLabels === null) {
            this.clearGame(matchID);
            this.notify(matchID);
            return;
        }
        if (!newStates) {
            return;
        }
        const prevStates = this.getData(matchID);
        if (!prevStates) {
            const categoryAllState = createAllCategoryState(newStates, !selected || selected.length === 0);
            const categories = { [ALL_CATEGORY_ID]: categoryAllState, };
            for (const categoryID of Object.keys(newStates)) {
                categories[categoryID] = Object.assign(Object.assign({}, newStates[categoryID]), config);
            }
            if (categoriesLabels) {
                categoriesLabels.forEach(({ id, txt }) => { categories[id].label = txt; });
                this.order.set(matchID, [ALL_CATEGORY_ID].concat(categoriesLabels.map(({ id }) => id)));
            }
            this.sportID[matchID] = sportID;
            this.data.set(matchID, categories);
            this.selectedCategories.set(matchID, new Set());
            this.select(matchID, selected || [], true);
            this.notify(matchID);
            return;
        }
        // обновляем существующие категории
        objectEntries(newStates).forEach(([categoryID, newState]) => {
            prevStates[categoryID] = Object.assign(prevStates[categoryID] || {}, newState, config);
        });
        prevStates[ALL_CATEGORY_ID] = createAllCategoryState(newStates, prevStates[ALL_CATEGORY_ID] && prevStates[ALL_CATEGORY_ID].isSelected);
        if (categoriesLabels) {
            categoriesLabels.forEach(({ id, txt }) => { prevStates[id].label = txt; });
            this.order.set(matchID, [ALL_CATEGORY_ID].concat(categoriesLabels.map(({ id }) => id)));
        }
        const updatedCategories = Object.keys(newStates).concat(ALL_CATEGORY_ID);
        const toDelete = Object.keys(prevStates).filter((categoryID) => updatedCategories.indexOf(categoryID) === -1);
        this.deleteCategories(matchID, toDelete);
        this.notify(matchID);
    }
    select(matchID, categoryIDs = Array.from(
    // @ts-ignore
    this.selectedCategories.has(matchID) && this.selectedCategories.get(matchID).values() || []), isSelected = true) {
        if (!this.selectedCategories.has(matchID)) {
            return;
        }
        const selectedCategories = this.selectedCategories.get(matchID);
        if (categoryIDs.indexOf(ALL_CATEGORY_ID) !== -1) {
            this.unselectCategories(matchID);
            return;
        }
        if (!isSelected) {
            this.unselectCategories(matchID, categoryIDs);
            return;
        }
        const unselectCategories = objectFromEntries(Array.from(selectedCategories.values() || [])
            .map((categoryID) => [categoryID, { isSelected: false }]));
        selectedCategories.clear();
        categoryIDs[0] && selectedCategories.add(categoryIDs[0]);
        const newStates = Object.assign(Object.assign({ [ALL_CATEGORY_ID]: { isSelected: selectedCategories.size === 0 } }, unselectCategories), { [categoryIDs[0]]: { isSelected: true } });
        this.selectTables(matchID);
        this.assignStates(matchID, newStates);
    }
    unselectCategories(matchID, categoryIDs = Array.from(
    // @ts-ignore
    this.selectedCategories.has(matchID) && this.selectedCategories.get(matchID).values() || [])) {
        const selectedCategories = this.selectedCategories.get(matchID);
        categoryIDs.forEach((c) => { selectedCategories.delete(c); });
        const noCategoriesSelected = (selectedCategories.size === 0);
        const newStates = Object.assign(
        // очередность важна, isSelected:true должны быть в конце
        !noCategoriesSelected && { [ALL_CATEGORY_ID]: { isSelected: false } }, objectFromEntries(categoryIDs.map((categoryID) => [categoryID, { isSelected: false }])), objectFromEntries(Array
            .from(selectedCategories.values() || [])
            .map((categoryID) => [categoryID, { isSelected: true }])), noCategoriesSelected && { [ALL_CATEGORY_ID]: { isSelected: true } });
        this.assignStates(matchID, newStates);
        this.selectTables(matchID);
    }
}
export function createAllCategoryState(data, isSelected = true) {
    const tables = objectValues(data).reduce((tables, state) => tables.concat(state.tables || []), []);
    return { tables, isSelected, isFavoriteDisabled: true };
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/store/line/outcomes.mobile/additional/categories/All.mobile.js